<template>
  <a :href="content.url" class="LoginLink">
    <LoginLabel>{{ content.text }}</LoginLabel>
  </a>
</template>

<script>
import LoginLabel from './LoginLabel.vue'

export default {
  components: {
    LoginLabel
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

.LoginLink {
  white-space: nowrap;
  transition: color 0.15s;
}

.LoginLink:hover {
  color: var(--brand-color);
}
</style>
